document.addEventListener('Searchanise.Loaded', function () {
  (function ($) {
    // ── CONFIGURATION ────────────────────────────────────────────

    // Use the same Theme Editor settings as the standard
    // New Lower Price label elsewhere in the theme.
    var snizeNewLowerPriceEnabled = true;

    var snizeBadgeMode = 
        'value'
    ;

    var snizeBadgeText = "NEW LOWER PRICE";

    var snizeBadgePrefix = "Reduced by";

    var snizeBadgeSuffix = "";

    // ─────────────────────────────────────────────────────────────

    if (!snizeNewLowerPriceEnabled) return;

    if (!$('#snize-new-lower-price-style').length) {
      $('head').append(
        `<style id="snize-new-lower-price-style">
          #snize_results .snize-new-lower-price-badge {
            display: block;
            position: absolute;
            top: 3px;
            left: 3px;
            background-color: #F2DC1C;
            color: #000000;
            font-size: 12px;
            font-weight: 600;
            padding: 3px 8px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
        </style>`
      );
    }

    $(document).on('Searchanise.ResultsUpdated', function (event, container) {
      setTimeout(function () {
        $('.snize-product', container).each(function () {
          let productData   = $(this).data('snize_item_data');
          if (!productData) return;

          // console.table(productData);
          // Object.keys(productData).forEach(function(key) {
          //   if (key.toLowerCase().includes('metafield')) {
          //     console.log(key, productData[key]);
          //   }
          // });

          let listPrice     = parseFloat(productData.list_price) || 0;
          let currentPrice  = parseFloat(productData.price) || 0;
          let newLowerPrice = parseFloat(productData.metafield_2e9ec427c1e66b1217687d6bbd3d1dee) || 0;

          if (listPrice > 0) return;

          if (newLowerPrice > 0 && currentPrice < newLowerPrice) {
            if ($('.snize-new-lower-price-badge', this).length) return;

            let saving = newLowerPrice - currentPrice;
            let badgeText;

            if (snizeBadgeMode === 'value') {
              badgeText = [snizeBadgePrefix, Searchanise.GetWidgets().formatPrice(saving), snizeBadgeSuffix].filter(Boolean).join(' ');
            } else if (snizeBadgeMode === 'percent') {
              badgeText = [snizeBadgePrefix, Math.round((saving / newLowerPrice) * 100) + '%', snizeBadgeSuffix].filter(Boolean).join(' ');
            } else {
              badgeText = snizeBadgeText;
            }

            $('.snize-thumbnail-wrapper', this).prepend(
              `<span class="snize-new-lower-price-badge">${badgeText}</span>`
            );
          }
        });
      }, 0);
    });

  })(window.Searchanise.$);
});